import React from "react";
import PropTypes from "prop-types";
import TextField from "./TextField";
import validateWithLMT from "../../lib/validation/validateWithLMT";

function Email(props) {
  const validator = validateWithLMT("email", props.validatorMessage, {}, props.delay);
  return <TextField {...props} validator={validator} type="email" />;
}

Email.defaultProps = {
  label: "Votre adresse email",
  name: "email",
  required: "Merci de saisir votre adresse email",
  validatorMessage: "Votre adresse email est incorrecte",
  variant: "outlined",
  delay: null,
};

Email.propTypes = {
  /**
   * methods du useForm()
   */
  methods: PropTypes.instanceOf(Object),
  /**
   * Label du champ
   */
  label: PropTypes.string,
  /**
   * Name du tag HTML input
   */
  name: PropTypes.string,
  /**
   * Message d'erreur si le champ est requis
   */
  required: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  /**
   * Message d'erreur si validation incorrecte
   */
  validatorMessage: PropTypes.string,
  /**
   * The variant to use
   * 'filled'
   * | 'outlined'
   * | 'standard'
   */
  variant: PropTypes.string,
  /**
   * Valeur par défaut du champ
   */
  defaultValue: PropTypes.string,
  /**
   * Délai en millisecondes pour la vérification de la valeur du champ par l'API
   */
  delay: PropTypes.number,
};

export default Email;
